WiseMetering.Views.NewZaptecIntegration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration',
    template: 'templates/integrations/zaptec/new',
    title: () => i18next.t('modal.title.integrations.new'),

    ui: {
        assetsList: '#integration_assets_list',
        sites: '#integration_site_id',
        configuration: '#integration_configuration_id',
        search: 'input#asset-search'
    },

    events: {
        'keyup input#asset-search': 'search',
        'change @ui.sites': 'onSiteChange'
    },

    initialize: function(options) {
        WiseMetering.Views.Modal.Save.prototype.initialize.call(this, options);

        this.partner_id = WiseMetering.integrationLicenses.get(this.model.get('license_id')).get('partner_id');
    },

    afterSave: function() {
        WiseMetering.indicators.fetch();
    },

    fetchExternalAssets: function(searchText) {
        this.modal.block();

        const payload = {
            license_id: this.model.get('license_id'),
            partner_id: this.partner_id,
            site_id: this.ui.sites.val(),
            configuration_id: this.ui.configuration.val(),
            search_text: searchText
        };

        $.ajax({
            url: `/integrations/external_assets`,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(payload),
            success: function(data) {
                const selectedElements = $('#assets-list').children('input:checked');

                selectedElements.each(function() {
                    const asset = $(this).add($(this).siblings());

                    asset.clone(true).appendTo('#current-assets-list');
                });

                this.ui.assetsList.empty();

                if (data.length > 0) {
                    this.fetchedAssets = data;
                    data.forEach(function(asset, index) {
                        this.ui.assetsList.html(WiseMetering.utils.optionsFromArray(data, null, 'reference', 'show_name', true));
                    }.bind(this));

                    $('#save').prop('disabled', false);
                } else {
                    this.ui.assetsList.html(`<p>${i18next.t('integration_assets.no_assets')}</p>`);
                }

                this.modal.unblock();
            }.bind(this),
            error: function(err) {
                const errors = err.responseJSON || null;
                let errorMessage = '';

                if (errors) {
                    Object.keys(errors).forEach(key => {
                        errorMessage += `${key.capitalize()}: ${errors[key].capitalize()} <br>`;
                    });
                } else {
                    errorMessage = 'An error occurred';
                }

                WiseMetering.layout.showTipper('error', errorMessage);
                this.modal.unblock();
            }.bind(this)
        });
    },

    getFormData: function() {
        let data = this.formSerializer();
        const
            fetchedAssets = this.fetchedAssets || [],
            asset = fetchedAssets.find(asset => asset.reference === data.reference);

        data.name = asset.name;
        data.partner_id = this.partner_id;
        data.serial_number = asset.serial_number;

        return data;
    },

    onShow: function() {
        const
            sites = WiseMetering.zones.activeSites(),
            configurations = WiseMetering.integrationConfigurations.where({ license_id: this.model.license().id }),
            configurationOptions = WiseMetering.utils.optionsFromModels(configurations, 'name', null, configurations.length !== 1);

        this.ui.sites.html(WiseMetering.utils.optionsFromModels(sites, 'name', null, sites.length !== 1));
        this.ui.configuration.html(configurationOptions);
    },

    search: function(event) {
        if (event && (event.keyCode || event.which) !== 13) {
            return;
        }

        if (this.ui.search.val().length < 2) {
            console.warn('missing search text, minimum 2 characters');
            return;
        }

        if (!this.ui.configuration.val()) {
            console.warn('missing configuration');
            return;
        }

        this.fetchExternalAssets(this.ui.search.val());
    }
});
